export const cloneObject = (value: any) => {
    if (value){
        let str = JSON.stringify(value);
        return JSON.parse(str);
    }
    return undefined;
}
